import { IonContent, IonPage } from '@ionic/react'
import { useDispatch } from 'react-redux'
import React from 'react'
import { useTranslation } from 'react-i18next'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import TripInformationContent from '../pageContent/TripInformation.content'
import { saveTripInformation } from '../store/tripInformation.actions'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'

const TripInformation: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const onBackClick = () => {
    history.push(TabConstants.CHART_ROUTE)
  }

  const onSaveClick = () => {
    dispatch(saveTripInformation())
  }

  return (
    <IonPage id='TripInformationPage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        isBackButton={true}
        nextLabel={t('common.buttons.Save')}
        nextOnClick={onSaveClick}
        title='Trip Information'
      />
      <IonContent color='light'>
        <TripInformationContent isPHI />
      </IonContent>
    </IonPage>
  )
}

export default TripInformation
